import BreadcrumbWrapper from '@/components/Breadcrumbs/BreadcrumbWrapper';
import useItemPageCategoryBreadcrumbs from '@/pages/Item/helpers/useItemPageCategoryBreadcrumbs';

type Props = {
    itemId: number;
};

export const PriceResultsPageBreadcrumbs = ({ itemId }: Props) => {
    const categoryBreadcrumbs = useItemPageCategoryBreadcrumbs(itemId);

    return (
        <BreadcrumbWrapper
            className="mx-0 mb-md mt-md w-min xsMax:my-sm xsMax:px-sm"
            crumbs={categoryBreadcrumbs}
        />
    );
};
